module.exports = __webpack_public_path__ + "img/premium_partner.5299e1b0.jpg";